module.exports = __webpack_public_path__ + "img/triangle-exclamation-solid.4ba03dd8.svg";